export const MobileWidth = '1190px';

export const SmallMobileWidth = '550px';

export const pmPurple = '#8A02CA';

export const pmPurpleLight = '#BD35FD';

export const pmWhite = '#fff';

export const pmBlack = '#000';

export const errorColor = 'red';

export const navigateCookie = 'hasNavigate';